const React = require('react');
const { ScreenRecognitionProvider } = require('@reckitt/phx-husky.contexts.screen-recognition');

exports.wrapRootElement = ({ element }) => (
  <ScreenRecognitionProvider>{element}</ScreenRecognitionProvider>
);
